// Example usage:
// printLineSigns({
//     doc,
//     startY: yPos,
//     labels2: null,
//     paddingPage: 0.5,
//     paddingCol: 0.4,
//     labels: ["ผู้ทำรายการ", "ผู้อนุมัติเบิก", "ผู้จ่ายเงิน"],
//     pageWidth: 8.3,
//     lineHeight: 0.21,
//     contentSize: 14,
//     fontName: "THSarabun"
//   })

export const printLineSigns = ({ doc, startY, labels2,
  paddingPage = 0.5,
  paddingCol = 0.2,
  labels = ["xx", "yy", "zz"],
  pageWidth = 8.3,
  lineHeight = 0.21,
  contentSize = 14,
  fontName = "THSarabun"
}) => {
  let yPos = startY
  const colWidth = (pageWidth - paddingPage * 2) / labels.length
  const paddingLine = paddingCol
  let col = 0
  doc.setFontSize(contentSize)
  for (const label of labels) {
    // const colX = paddingPage  + paddingCol + (col * colWidth)
    const startX = paddingPage + col * colWidth
    const colX = startX + colWidth / 2
    doc.line(colX - colWidth / 2 + paddingLine, yPos, colX + colWidth / 2 - paddingLine, yPos)

    doc.setFont(fontName, "bold")
    doc.text(label, colX, yPos + lineHeight, { align: "center" })

    doc.setFont(fontName, "normal")
    labels2?.[col] && doc.text(labels2[col], colX, yPos + lineHeight * 2, { align: "center" })

    col++
  }
}